import { render, staticRenderFns } from "./PaymentSuccessfulMessage.vue?vue&type=template&id=3196eec4&"
import script from "./PaymentSuccessfulMessage.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccessfulMessage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSuccessfulMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports